module.exports = __webpack_public_path__ + "static/media/3.1e5748a9.jpg";